import axios from 'axios';
import { FC } from 'react';
import { getProfileApiRoot } from '../../utils/getProfileApiRoot';

export interface LastLogOnSetupProps { }
export const lastLogOnKey = 'user.LastLogOn';
const LastLogOnSetup: FC<LastLogOnSetupProps> = () => {
  const lastLogOn = sessionStorage.getItem(lastLogOnKey);

  if (!lastLogOn) {
    sessionStorage.setItem(lastLogOnKey, 'done');

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    axios.put(
      `${getProfileApiRoot()}/account/login-date`,
    );
  }
  return null;
};

export default LastLogOnSetup;
